<template>
  <div class="loadingField">
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </div>
</template>

<script>
export default {
  name: "Loading",
};
</script>